import { AddOnsAPI as AddOnsBusSchedAPI } from '../../../api/bussched/AddOnsAPI';
import { AddOnsAPI as AddOnsFilesAPI } from '../../../api/files/AddOnsAPI';
import { AddOnsAPI as AddOnsDataManagerAPI } from '../../../api/datamanager/AddOnsAPI';


class AddOnsCommand {

    constructor(API){
        this.API = API;
    }

    get(successCallback, errorCallback) {
        if(undefined !== this.API){
            const apiResult = this.API.get();
            apiResult.then((result) => {
                if (undefined !== successCallback) {
                    successCallback(JSON.parse(result));
                }
            }).catch(() => {
                if (undefined !== errorCallback) {
                    errorCallback("Ocorreu a obter os Add-Ons");
                }
            });
        }else{ 
            errorCallback("Ocorreu um erro a obter os Add-Ons");
        }
    }

    execute(addOn, label, parameters, successCallback, errorCallback) {
        if(undefined !== this.API){
            const apiResult = this.API.execute(addOn, parameters);
            apiResult.then((_) => {
                if (undefined !== successCallback) {
                    successCallback(`Sucesso a ${label}`);
                }
            }).catch(() => {
                if (undefined !== errorCallback) {
                    errorCallback(`Ocorreu um erro a ${label}`);
                }
            });
        }else{
            errorCallback("Ocorreu um erro a obter os Add-Ons");
        }
    }
}

export class AddOnsFilesCommand extends AddOnsCommand{
    constructor(){
        super(AddOnsFilesAPI);
    }
}

export class AddOnsBusSchedCommand extends AddOnsCommand{
    constructor(){
        super(AddOnsBusSchedAPI);
    }
}

export class AddOnsDataManagerCommand extends AddOnsCommand{
    constructor(){
        super(AddOnsDataManagerAPI);
    }
}
